import { combineReducers } from 'redux'
import basicRequest from '../../../../core/redux/reducers/request'

const show = basicRequest('VENDOR_JOB_SHOW')
const files = basicRequest('VENDOR_JOB_FILES')

export default combineReducers({ show, files })
